'use strict';

var button = require('../../../../../../../../../../_virtual/button.cjs');
var intentionColors = require('../../base/ds5/intentionColors.cjs');

var hasRequiredButton;

function requireButton () {
	if (hasRequiredButton) return button.__exports;
	hasRequiredButton = 1;

	var intentionColors$1 = intentionColors.__require();

	var TERTIARY_BUTTON_INTENTIONS = /*#__PURE__*/ function(TERTIARY_BUTTON_INTENTIONS) {
	    TERTIARY_BUTTON_INTENTIONS[TERTIARY_BUTTON_INTENTIONS["neutral"] = intentionColors$1.INTENTION_COLORS.neutral] = "neutral";
	    TERTIARY_BUTTON_INTENTIONS[TERTIARY_BUTTON_INTENTIONS["inverse"] = intentionColors$1.INTENTION_COLORS.inverse] = "inverse";
	    return TERTIARY_BUTTON_INTENTIONS;
	}({});

	button.__exports.TERTIARY_BUTTON_INTENTIONS = TERTIARY_BUTTON_INTENTIONS;
	
	return button.__exports;
}

exports.__require = requireButton;
//# sourceMappingURL=button.cjs.map
